import { createSelector } from '@reduxjs/toolkit';
import { GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_EXPANDED_WIDTH } from 'nav-meta/constants';
const getVerticalNavWidth = state => state.navLayoutDimensionsState.rootNav.VerticalNav.width;
export const getIsVerticalNavPinned = createSelector([getVerticalNavWidth], verticalNavWidth => {
  return !!(verticalNavWidth && verticalNavWidth === parseInt(GLOBAL_NAVIGATION_SIDEBAR_DEFAULT_EXPANDED_WIDTH, 10));
});